import { render, staticRenderFns } from "./FormItemList.vue?vue&type=template&id=83ba94f4&scoped=true&"
import script from "./FormItemList.vue?vue&type=script&lang=js&"
export * from "./FormItemList.vue?vue&type=script&lang=js&"
import style0 from "./FormItemList.vue?vue&type=style&index=0&id=83ba94f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ba94f4",
  null
  
)

export default component.exports